<template>
    <div class="date-range-filter-wrapper">
        <div class="row align-items-center g-3">
            <div class="col-auto">
                <label class="form-label mb-0">Start Date:</label>
            </div>
            <div class="col-auto">
                <input
                    type="date"
                    class="form-control"
                    v-model="localStartDate"
                >
            </div>
            <div class="col-auto">
                <label class="form-label mb-0">End Date:</label>
            </div>
            <div class="col-auto">
                <input
                    type="date"
                    class="form-control"
                    v-model="localEndDate"
                >
            </div>
            <div class="col-auto">
                <button class="btn btn-primary btn-md" @click="applyFilter">
                    <i class="fas fa-check me-1"></i> Apply
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-outline-secondary btn-md" @click="resetFilter">
                    <i class="fas fa-undo"></i> Reset
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DateRangeFilter',
    props: {
        startDate: { type: String, required: true },
        endDate: { type: String, required: true }
    },
    data() {
        return {
            localStartDate: this.startDate,
            localEndDate: this.endDate
        }
    },
    watch: {
        startDate(newVal) {
            this.localStartDate = newVal
        },
        endDate(newVal) {
            this.localEndDate = newVal
        }
    },
    emits: ['update:startDate', 'update:endDate', 'reset', 'apply'],
    methods: {
        applyFilter() {
            this.$emit('update:startDate', this.localStartDate)
            this.$emit('update:endDate', this.localEndDate)
            this.$emit('apply', {
                startDate: this.localStartDate,
                endDate: this.localEndDate
            })
        },
        resetFilter() {
            const endDate = new Date()
            const startDate = new Date()
            startDate.setMonth(startDate.getMonth() - 2)
            
            this.localEndDate = endDate.toISOString().split('T')[0]
            this.localStartDate = startDate.toISOString().split('T')[0]
            this.$emit('reset')
        }
    }
}
</script>
